<template>
   <div class="animated fadeIn">
      <b-breadcrumb>
         <h4>Sampling</h4>
      </b-breadcrumb>
      <b-row style="margin-top:10px;">
         <b-col sm="12">
            <b-card header-tag="header" >
               <div class="col-md-12" style="margin-top:10px;margin-bottom:10px;">

                  <span class="col-md-4">
                    <router-link to="/sampling_requested" tag="button" class="btn btn-light ">Requested</router-link>
                  </span>

                  <span class="col-md-4">
                    <router-link to="/sampling_requested" tag="button" class="btn btn-primary ">In Progress </router-link>
                  </span>
                  <span class="col-md-4">
                     <router-link to="/sampling_approved" tag="button" class="btn btn-light ">Approved </router-link>
                  </span>

               </div>

              <div class="col-12">
                <table class="table table-image">
                  <thead>
                    <tr>
                      <th scope="col">Design</th>
                      <th scope="col">Requested Sample</th>
                      <th scope="col">Factory</th>
                       
                       <th scope="col">Requested Size</th>
                      <th scope="col">Status</th>
                      
                    </tr>
                  </thead>

                  <tbody>
                    <tr v-for="item in items">
                      <td>

                        <span class="col-md-4">
                         <img  v-bind:src="item.default_image" height="42" width="42" />
                        </span>        
                        <span id="design" class="col-md-4">
                         {{item.design_title}}</p>
                        </span> 
                      </td>
                      <td>
                        <span> {{item.sample_type}} </span><br>
                        <span>on {{item.created_date}}<br>
                         
                        </span>
                      </td>
                      <td><span> {{item.factory}} </span><br>
                        <span>Due on {{item.due_date}}</span>
                      </td>
                      <td>
                        
                        <span class='align-center'>{{item.requested_size}}</span> 
                        
                      </td>

                      <td><span style="color: #32CD32">
                         
                        <span v-if="item.sample_status=='1'"  style="color: orange">Dispatch</span><br/>
                        <span>{{item.updated_date}}</span>
                         
                        </span>
                        
                      </td>
                               
                    </tr>

                    <tr v-if="totalInProgress<=0">
                      <td colspan="5" class="text-center">No Records Available to Display.</td>
                    </tr>

                  </tbody>
                </table>   
              </div>

            </b-card>

         </b-col>
      </b-row>
   </div>
</template>

<script>
    import CONSTANTS from "@/utils/constants";
    import Utils from "@/utils";
    import auth from "@/utils/auth";
    const axios = require('axios');

  export default {
    data() {
      return {
        
        
        borderless: false,
        hover: true,
        headVariant: null,
        tableVariant: '',
      	rows: 100,
        currentPage: 3,
        requestSampleModal: false,
        block_value: 1,
        selectedDate: new Date(),
        items:[],
        result:[],
        totalApproved:0,
        totalInProgress:0


      };
  },
      created: function() {
        this.samplingdetails();
      },
       methods: {
          requestsample: function(value) {
          this.requestSampleModal = !this.requestSampleModal;
        },

        
      // Function to Get Sample Listing
      samplingdetails: function() 
      {

          var userData = localStorage.getItem('userData');

          if (userData) 
          {

            var userInfo = JSON.parse(userData)
            this.vendor_id = userInfo[0].vendor_id; 

           const Obj = {
                vendor_id: this.vendor_id,
                sample_status: 1
              
              }

            this.isBusy = true;      
            axios.post(`${CONSTANTS.API_URL}/samplingdetails`,Obj)
            .then(response => {
              this.result = response.data

              if (this.result.returnmsg === 'Successful') {
                this.items  = this.result.returnvalue;
                this.totalInProgress = this.result.returnvalue.length;
                this.isBusy = !this.isBusy;
                
              }else {
               this.collection_list =[];
               this.totalInProgress=0;
                 this.isBusy = !this.isBusy;
              }


            })
            .catch(e => {
              this.errors.push(e)
            })

          }

      },
        

      },
    
  }
</script>
<style type="text/css">
th{
  background-color:white;
}
	#logo{
		    width: 40px;
    		height: 50px;
	}

	#pageno{
		float:right;
		position: absolute;
		margin-left: 500px;
	}
    .sample_button{
        /*float: right;*/
        position: absolute;
        left: 918px;

    }
    #samplemodal{
        /*width: auto;*/
        /*margin: auto !important;*/

    }
    .number_icon{
        background-color: #0066ff;
        border-radius: 50%;
        border: 1px solid;
        padding: 2px;

    }
    .number_icon2{
        background-color: #a6a6a6;
        border-radius: 100%;
        border: 1px solid;
        float: right;
    }
     .line{
        width: 112px;
        height: 47px;
        border-bottom: 1px solid black;
        /*position: absolute;*/
        }


.sampleicon{
    top: 20px;
    left: 80px;
}




/* Create a custom checkbox */
.checkmark {
  position: absolute;
  top: 0;
  left: 0;
  border-radius: 50%;
  height: 20px;
  width: 20px;
  background-color: #eee;
}




/* Create the checkmark/indicator (hidden when not checked) */
.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}






#imgdiv{
    
    width: 100px;
    height: 70px;
    margin-left: 77px;
    position: relative;
    /*right: 64px;*/
    /*margin-left: 143px;*/
} 
</style>